
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import WebViewHeader from './WebViewHeader.vue'
import { embedded } from '@/utils/react-native-webview'
import { Action, Getter } from 's-vuex-class'
import OfflineBanner from '@/mobile/src/components/OfflineBanner.vue'
import OfflineScreen from '@/mobile/src/views/OfflineScreen.vue'

/**
 * This is a wrapper for scaffolding web view screens in a consistent way
 */

@Component<WebViewScreen>({
    components: {
        OfflineScreen,
        OfflineBanner,
        WebViewHeader,
    },
})
export default class WebViewScreen extends Vue {
    @Prop({ type: String, default: '' }) public title!: string
    @Prop({ type: Boolean, default: false }) public hideHeader!: boolean
    @Prop({ type: Boolean, default: false }) public noPad!: boolean
    @Prop({ type: Boolean, default: false }) public showGoBack!: string
    @Prop({ type: Boolean, default: false }) public avoidKeyboard!: boolean
    @Prop({ type: Boolean, default: false }) public disableWhenOffline!: boolean

    @Action public setSlide

    @Getter
    hasNetworkConnection!: boolean

    private embedded: boolean = embedded
    private statusBarHeight = 0
    private screenHeight = '100%'

    public get style() {
        return {
            height: this.screenHeight,
        }
    }

    public get showOfflineScreen() {
        return this.disableWhenOffline && !this.hasNetworkConnection
    }

    public mounted() {
        if (this.avoidKeyboard) {
            window.addEventListener('message', this.onMessageReceived)
        }
        if (embedded) {
            this.setHeight()
        }
    }

    public setHeight() {
        if (window.STATUS_BAR_HEIGHT) {
            this.statusBarHeight = window.STATUS_BAR_HEIGHT
            return
        }
        setTimeout(this.setHeight, 250)
    }

    private beforeDestroy() {
        if (this.avoidKeyboard) {
            window.removeEventListener('message', this.onMessageReceived)
        }
    }

    private goBack() {
        this.$router.back()
    }

    // adjust screen height
    private onMessageReceived(message) {
        if (!message || !message.data || typeof message.data !== 'string') {
            return // vue dev tools seems sending invalid data to this function
        }
        const { event, value } = JSON.parse(message.data)
        if (event === 'keyboardDidShow') {
            this.screenHeight = `calc(100vh - ${
                value - window.STATUS_BAR_HEIGHT + 20
            }px)`
        }
        if (event === 'keyboardDidHide') {
            const offset = window.STATUS_BAR_HEIGHT
            this.screenHeight = '100%'
        }
    }
}
